import React from "react";

import { Dropdown, Slider, Switch, SvgIcon } from "../../ui-helpers";

import {
  FingerSize,
  // RingSizes,
  SliderContainer,
  IconWithTitle,
  SwitchContainer,
  Notification,
  InfoIcon,
  Info,
  SliderTitle,
  DimensionsSliders,
  ShapeContainer,
  Image,
  ShapeWrapper,
  ShapeTitle
} from "./Dimensions-styled";

import { RingModel } from "../../../../Model/RingModel";
import { IRingState } from "../../../../Controller/RingStateController/RingStateController";

interface Props {
  fingerSize: string;
  fingerSizeOptions: string[];
  onFingerSizeChange: (value: string) => void;

  fingerSizeFormat: string;
  fingerSizeFormatOptions: string[];
  onFingerSizeFormatChange: (value: string) => void;

  ringWidth: number;
  ringWidthOptions: number[];
  onRingWidthChange: (value: number) => void;

  ringThickness: number;
  ringThicknessOptions: number[];
  onRingThicknessChange: (value: number) => void;

  autoRatio: boolean;
  onAutoRatioChange: (value: boolean) => void;

  checkoutIssues: ("fingerSize" | "debug")[];

  scrolling: boolean;
  rings: RingModel[];
  ringState: IRingState;
  setShape: () => void;
  assetURI: string;
}

export default class extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  } // /constructor()

  render = () => {
    const {
      fingerSize,
      onFingerSizeChange,
      fingerSizeFormat,
      fingerSizeFormatOptions,
      onFingerSizeFormatChange,
      ringWidth,
      ringWidthOptions,
      onRingWidthChange,
      ringThickness,
      ringThicknessOptions,
      onRingThicknessChange,
      autoRatio,
      onAutoRatioChange,
      checkoutIssues,
      scrolling,
      rings,
      ringState,
      setShape,
      assetURI,
    } = this.props;

    const fingerSizeOptions = this.props.fingerSizeOptions.map((fso) => {
      fso = fso.replace("1/4", "¼");
      fso = fso.replace("1/2", "½");
      fso = fso.replace("3/4", "¾");
      return fso;
    });

    return (
      <div className="threed-configurator-menu-dimensions-tab">
        <FingerSize>
          <Dropdown
            title="Finger size"
            titleFontWeight={700}
            width={150}
            opacity={1}
            defaultOption={fingerSize}
            options={fingerSizeOptions}
            onChange={onFingerSizeChange}
            highlight={checkoutIssues.includes("fingerSize")}
          />
          <Dropdown
            title="Size format"
            titleFontWeight={700}
            width={150}
            opacity={0.5}
            defaultOption={fingerSizeFormat}
            options={fingerSizeFormatOptions}
            onChange={onFingerSizeFormatChange}
          />
        </FingerSize>

        <DimensionsSliders>
          <SliderContainer className="threed-configurator-slider-container">
            <SliderTitle>Width</SliderTitle>

            <Slider
              disabled={false}
              defaultValue={ringWidth}
              options={ringWidthOptions}
              onChange={onRingWidthChange}
              tooltipVisible={!scrolling}
            />
          </SliderContainer>

          <SliderContainer className="threed-configurator-slider-container">
            <SliderTitle>Thickness</SliderTitle>

            <Slider
              disabled={autoRatio}
              defaultValue={ringThickness}
              options={ringThicknessOptions}
              onChange={onRingThicknessChange}
              tooltipVisible={!scrolling}
            />
          </SliderContainer>
        </DimensionsSliders>

        <SwitchContainer>
          <Notification>
            <InfoIcon>
              <SvgIcon type="info" style={{ pointerEvents: "none" }} />
            </InfoIcon>
            <Info>Select optimal width and thickness ratio automatically</Info>
          </Notification>
          <Switch defaultChecked={autoRatio} onChange={onAutoRatioChange} />
        </SwitchContainer>

        {rings?.length == 2 && (
          <ShapeContainer>
            {rings.map((r, rKey) => {
              const isActive = r._SKU == ringState.ringModel.SKU;
              const imgUrl = `${r._shape.replace(/\s/g, "")}_${isActive ? 'Gold' : 'Gray'}`;
              return (
                <ShapeWrapper 
                  key={rKey} 
                  onClick={()=>setShape(r._SKU)}
                >
                  <ShapeTitle isActive={isActive}>{r._shape}</ShapeTitle>
                  <Image src={`${assetURI}/images/shape/${imgUrl}.png`} />
                </ShapeWrapper>
              );
            })}
          </ShapeContainer>
        )}
      </div>
    );
  }; // /render()
} // /class
